const Categories  = [
    {
        id: 'backgrounds',
        colors: [],
        items: [ 'bg_attic', 'bg_autumn', 'bg_bricks', 'bg_city', 'bg_forest', 'bg_lounge', 'bg_night', 'bg_parksummer', 'bg_parkwinter', 'bg_water' ],
        division: 6,
        txt: {
            fr: 'Décor',
            en: 'Background'
        }
    },
    {
        id: 'silhouettes',
        colors: [ 'skin_1', 'skin_2', 'skin_3', 'skin_4', 'skin_5', 'skin_6', 'skin_7', 'skin_8', 'skin_9' ],
        items: [ 'silhouette_01', 'silhouette_02', 'silhouette_03', 'silhouette_04', 'silhouette_05', 'silhouette_06', 'silhouette_07', 'silhouette_08' ],
        division: 6,
        txt: {
            fr: 'Silhouettes',
            en: 'Silhouettes'
        }
    },
    {
        id: 'eyes',
        colors: [ 'dark_brown', 'brown', 'dark_blue', 'green', 'red', 'blue', 'purple', 'orange', 'pink', 'yellow' ],
        items: [ 'eyes_01', 'eyes_02', 'eyes_03', 'eyes_04', 'eyes_05', 'eyes_06', 'eyes_07', 'eyes_08', 'eyes_09', 'eyes_10', 'eyes_11', 'eyes_12' ],
        division: 6,
        txt: {
            fr: 'Yeux',
            en: 'Eyes'
        }
    },
    {
        id: 'eyebrows',
        colors: [ 'dark_brown', 'brown', 'dark_blue', 'green', 'red', 'blue', 'purple', 'orange', 'pink', 'yellow' ],
        items: [ 'eyebrows_01', 'eyebrows_02', 'eyebrows_03', 'eyebrows_04', 'eyebrows_05', 'eyebrows_06', 'eyebrows_07', 'eyebrows_08', 'eyebrows_09' ],
        division: 6,
        txt: {
            fr: 'Sourcils',
            en: 'Eyebrows'
        }
    },
    {
        id: 'noses',
        colors: [ 'dark_brown', 'brown', 'dark_blue', 'green', 'red', 'blue', 'purple', 'orange', 'pink', 'yellow' ],
        items: [ 'nose_01', 'nose_02', 'nose_03', 'nose_04', 'nose_05', 'nose_06', 'nose_07', 'nose_08' ],
        division: 6,
        txt: {
            fr: 'Nez',
            en: 'Noses'
        }
    },
    {
        id: 'mouths',
        colors: [ 'dark_brown', 'brown', 'dark_blue', 'green', 'red', 'blue', 'purple', 'orange', 'pink', 'yellow' ],
        items: [ 'mouth_01', 'mouth_02', 'mouth_03', 'mouth_04', 'mouth_05', 'mouth_06', 'mouth_07', 'mouth_08', 'mouth_09', 'mouth_10' ],
        division: 6,
        txt: {
            fr: 'Bouches',
            en: 'Mouths'
        }
    },
    {
        id: 'hair',
        colors: [ 'dark_brown', 'brown', 'dark_blue', 'green', 'red', 'blue', 'purple', 'orange', 'pink', 'yellow' ],
        items: [ 'hair_01', 'hair_02', 'hair_03', 'hair_04', 'hair_05', 'hair_06', 'hair_07', 'hair_08', 'hair_09', 'hair_10', 'hair_11', 'hair_12', 'hair_13', 'hair_14', 'hair_15' ],
        division: 6,
        txt: {
            fr: 'Cheveux',
            en: 'Hair'
        }
    },
    {
        id: 'clothing',
        colors: [],
        items: [ 'clothing_01', 'clothing_02', 'clothing_03', 'clothing_04', 'clothing_05', 'clothing_06', 'clothing_07', 'clothing_08', 'clothing_09', 'clothing_10', 'clothing_11', 'clothing_12', 'clothing_13' ],
        division: 6,
        txt: {
            fr: 'Vêtements',
            en: 'Clothing'
        }
    },
    {
        id: 'accessories',
        colors: [],
        items: [ 'glasses_01', 'glasses_02', 'glasses_03', 'glasses_04', 'confetti', 'hat', 'butterflies', 'balloons', 'bird', 'earrings_02', 'earrings_01', 'flower', 'leaf', 'crown', 'tuque' ],
        division: 6,
        txt: {
            fr: 'Accessoires',
            en: 'Accessories'
        }
    },
    {
        id: 'other',
        colors: [],
        items: ['paintsplatter', 'horse', 'helmet', 'spoon', 'beachball', 'flowers', 'necklace', 'chain', 'tie', 'cat', ],
        division: 6,
        txt: {
            fr: 'Autres',
            en: 'Other'
        }
    }

    // accessories 

]

export { Categories }





// WEBPACK FOOTER //
// ./src/components/defis/js/Categories.js